<template>
  <div class="w-full max-w-[300px]">
    <skeleton class="h-[284px]" />
    <div class="flex flex-col p-3">
      <div class="mb-2 flex flex-col">
        <skeleton class="mb-2 max-w-[50px]" />
        <skeleton class="h-14" />
      </div>
      <skeleton class="mb-10 h-7 max-w-[109px]" />
      <div class="flex h-10">
        <skeleton class="mr-2 h-full max-w-[153px]" />
        <skeleton class="h-full max-w-[40px]" />
      </div>
    </div>
  </div>
</template>
